module.exports = __webpack_public_path__ + "static/media/27-12.faa60bcc.mp3";